import mainViewMixin from './mainViewMixin';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewNiotaClassicOriginators',
  mixins: [mainViewMixin],
  data: function () {
    return {};
  },
  computed: {
    headerBG() {
      return './img/consumer.png';
    }
  },
  methods: {
    selectedType(type) {
      this.editedItem.type = type;
      this.editedItem = cloneDeep(this.editedItem);
    },
    resetType() {
      delete this.editedItem.type;
      this.editedItem = cloneDeep(this.editedItem);
    }
  }
};